import {
    SET_ICONS,
} from "@/shared/components/icons_selector/store/types/types.js";

const mutations = {
    [SET_ICONS]: (state, payload) => state.icons_list = payload,

};

export default mutations